import React from 'react';

/**
 * Mono uppercase label with a trailing hairline - used to group PA messages
 * by temporal context ("This morning", "A few minutes ago", etc.).
 */
export function TimeDivider({ label }: { label: string }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        margin: '28px 0 8px',
      }}
    >
      <span
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 10,
          letterSpacing: '1.4px',
          textTransform: 'uppercase',
          color: 'var(--ink-faint)',
        }}
      >
        {label}
      </span>
      <span
        aria-hidden
        style={{ flex: 1, height: 1, background: 'var(--rule)' }}
      />
    </div>
  );
}
